export const getMenuCategories = categories => categories.sortedIds.map(id => ({
  title: categories.byId[id].name,
  imageSrc: categories.byId[id].image,
  isActive: categories.byId[id].active,
  id,
}));

export const getMenuSubcategories = (
  subcategories,
  categories,
  selectedCategoryId,
) => (
  selectedCategoryId
    ? categories.byId[selectedCategoryId].subcategoryIds.map(id => ({
      title: subcategories[id].name,
      id,
    }))
    : Object.keys(subcategories).map(id => ({
      title: subcategories[id].name,
      id: parseInt(id, 10),
    })));

export const getMenuItems = (
  categories,
  selectedCategoryId,
  items,
  sizes,
) => categories.byId[selectedCategoryId].itemIds.map(itemId => ({
  name: items[itemId].name.toUpperCase(),
  isActive: items[itemId].active,
  price: sizes[items[itemId].sizeIds[0]].price,
  specialPrice: sizes[items[itemId].sizeIds[0]].specialPrice,
  subtitle: items[itemId].subtitle.toUpperCase(),
  imageSrc: items[itemId].image[0]?.src,
  id: itemId,
  subcategoryId: items[itemId].subcategoryId ? (items[itemId].subcategoryId).toString() : '',
}));

